<template>
  <v-form ref="form" v-model="validacion" lazy-validation>
    <div id="aplicacion-solicitudes">
      <template>
        <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
          <v-icon right dark>arrow_back_ios</v-icon>Volver
        </v-btn>
      </template>
      <v-layout align-center justify-center>
        <v-flex lg10>
          <v-card>
            <v-container>
              <v-toolbar
                v-if="
                  usuarioLoggedTipe == 'PROVEEDOR' ||
                  usuarioLoggedTipe == 'ADMINISTRADOR'
                "
                color="white"
                dark
                flat
                dense
                cad
              >
                <v-toolbar-title class="indigo--text"
                  >Gestionar Cambio</v-toolbar-title
                >
              </v-toolbar>
              <v-toolbar
                v-if="usuarioLoggedTipe == 'AGENCIA'"
                color="white"
                dark
                flat
                dense
                cad
              >
                <v-toolbar-title class="indigo--text"
                  >Solicitud de Cambio</v-toolbar-title
                >
              </v-toolbar>
              <v-card>
                <v-container>
                  <v-toolbar color="white" dark flat dense cad>
                    <v-toolbar-title class="indigo--text"
                      >Datos Establecimiento</v-toolbar-title
                    >
                  </v-toolbar>
                  <br />
                  <v-layout>
                    <v-flex md6>
                      <p>Establecimiento: {{ this.establecimiento }}</p>
                    </v-flex>
                    <v-flex md2>
                      <p>Nivel : {{ this.nivel }}</p>
                    </v-flex>
                    <v-flex md3>
                      <p>Código Curso : {{ this.codigoCurso }}</p>
                    </v-flex>
                    <v-flex md2>
                      <p>Letra : {{ this.letra }}</p>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
              <br />
              <v-card>
                <v-container>
                  <v-toolbar color="white" dark flat dense cad>
                    <v-toolbar-title class="indigo--text"
                      >Solicitud de Cambio</v-toolbar-title
                    >
                  </v-toolbar>
                  <v-layout>
                    <v-flex md3>
                      <v-text-field
                        v-model="rutSupervisor"
                        label="Rut  "
                        counter="10"
                        maxlength="10"
                        :box="isDisabled"
                        :readonly="isDisabled"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md1></v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="nombreSupervisor"
                        label="Nombre "
                        :box="isDisabled"
                        :readonly="isDisabled"
                        @input="$v.apellido1.$touch()"
                        @blur="
                          tipeView == 'crear' ? $v.apellido1.$touch() : null
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md1></v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="apellidoSupervisor"
                        label="Apellido"
                        :box="isDisabled"
                        :readonly="isDisabled"
                        @input="$v.apellido1.$touch()"
                        @blur="
                          tipeView == 'crear' ? $v.apellido1.$touch() : null
                        "
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12 sm6>
                      <v-textarea
                        v-if="tipeView != 'consulta'"
                        v-model="observacionesSup"
                        label="Observaciones"
                        :box="isDisabledOb"
                        :readonly="isDisabledOb"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12 md1></v-flex>
                    <v-select
                      v-model="rolValue"
                      :items="rolSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Rol"
                      :box="isDisabledOb"
                      :readonly="isDisabledOb"
                    ></v-select>
                  </v-layout>
                </v-container>
              </v-card>
              <br />
              <v-card
                v-if="
                  usuarioLoggedTipe == 'PROVEEDOR' ||
                  usuarioLoggedTipe == 'ADMINISTRADOR'
                "
              >
                <v-container>
                  <v-toolbar color="white" dark flat dense cad>
                    <v-toolbar-title class="indigo--text"
                      >Gestionar el Cambio</v-toolbar-title
                    >
                  </v-toolbar>
                  <v-layout>
                    <v-flex md3>
                      <v-text-field
                        v-model="rutExaminador"
                        label="Rut "
                        counter="10"
                        maxlength="10"
                        @input="dvRut()"
                        @focusout="checkRut"
                        @blur="tipeView == 'crear' ? $v.rut.$touch() : null"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md1></v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="nombreExaminador"
                        label="Nombre "
                        @input="$v.apellido1.$touch()"
                        @blur="
                          tipeView == 'crear' ? $v.apellido1.$touch() : null
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md1></v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="apellidoExaminador"
                        label="Apellido"
                        @input="$v.apellido1.$touch()"
                        @blur="
                          tipeView == 'crear' ? $v.apellido1.$touch() : null
                        "
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12 sm6>
                      <v-textarea
                        v-model="observacionesExa"
                        label="Observaciones"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12 md1></v-flex>
                    <v-select
                      v-model="rolValue"
                      :items="rolSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Rol"
                    ></v-select>
                  </v-layout>
                </v-container>
              </v-card>
              <v-card-actions class="pb-3">
                <v-btn
                  v-if="tipeView == 'consulta' ? false : true"
                  color="primary"
                  dark
                  class="mb-2"
                  @click="save()"
                >
                  Guardar
                  <v-icon right dark>save</v-icon>
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </v-form>
</template>

<script>
import Vue from "vue";
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
import { error } from "util";

export default {
  name: "",
  components: {},
  mixins: [misMixins, validationMixin],
  props: {},
  data() {
    return {
      rolValue: "",
      rolSelect: [{ nombre: "EXAMINADOR" }, { nombre: "SUPERVISOR" }],
      validacion: false,
      rutExaminador: "",
      dvExaminador: "",
      rutSupervisor: "",
      dvSupervisor: "",
      nombreExaminador: "",
      nombreSupervisor: "",
      apellidoExaminador: "",
      apellidoSupervisor: "",
      hallazgo1: "",
      hallazgo2: "",
      documentoId: "",
      id: "",
      tipeView: "",
      observacionesSup: "",
      observacionesExa: "",
      codigoCurso: "",
      nivel: "",
      establecimiento: "",
      letra: "",
    };
  },
  validations: {
    nombre: { required },
    apellido: { required },
    apellido1: { required },
    rut: { required },
  },

  computed: {
    rutErrors() {
      const errors = [];
      if (!this.$v.rut.$dirty) return errors;
      !this.$v.rut.required && errors.push("Rut es obligatorio.");
      return errors;
    },
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push("Nombre es obligatorio.");
      return errors;
    },
    apellidoErrors() {
      const errors = [];
      if (!this.$v.apellido.$dirty) return errors;
      !this.$v.apellido.required && errors.push("Apellido es obligatorio.");
      return errors;
    },
    isDisabled() {
      if (this.tipeView == "modifica") {
        return true;
      }
    },
    isDisabledOb() {
      if (
        this.tipeView == "modifica" &&
        this.usuarioLoggedTipe == "PROVEEDOR"
      ) {
        return true;
      }
    },
  },
  mounted() {},
  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.id = this.$route.params.id;
    this.tipeView = this.$route.params.tipeView;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.codigoCurso = this.$route.params.codigoCurso;
    this.nivel = this.$route.params.nivel;
    this.establecimiento = this.$route.params.establecimiento;
    this.letra = this.$route.params.letra;
    this.rut = this.$route.params.rut;
    this.dv = this.$route.params.dv;
    this.rutSupervisor = this.rut + "-" + this.dv;
    this.nombreSupervisor = this.$route.params.nombre;
    this.apellidoSupervisor = this.$route.params.apellido;
    this.observacionesSup = this.$route.params.observaciones;
    this.rolValue = this.$route.params.rol;
  },

  methods: {
    volver() {
      this.$router.back();
    },
    dvRut() {
      let f = this.formateaRut(this.rutExaminador);
      if (f == undefined) {
        this.rutExaminador = this.rutExaminador;
      } else {
        this.rutExaminador = f;
      }
    },
    checkRut() {
      let v = this.validaRut(this.rutExaminador);

      if (v === false) {
        return console.log("false");
      } else {
        //esto es para hacer algun tipo de validacion
        this.dv = obtenerDv(this.rutExaminador);
        return console.log("verdadero");
      }
    },
    save() {
      if (this.tipeView == "modifica" && this.usuarioLoggedTipe == "AGENCIA") {
        this.saveSolicitud();
      } else {
        this.saveGestionar();
      }
    },
    saveSolicitud() {
      let idContrato = this.$store.getters.contratoStored;
      //let id = this.id;
      let dv = this.obtenerDv(this.rutSupervisor);
      let rut = this.obtenerSoloRut(this.rutSupervisor);

      this.body = {
        idContrato: idContrato,
        rut: rut,
        dv: dv,
        codigoCurso: this.codigoCurso,
        nivel: this.nivel,
        observaciones: this.observacionesSup,
        rol: this.rolValue,
      };
      axios
        .post("candidatos/seleccion/solicitudCambio", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.volver();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error);
        });
    },
    saveGestionar() {
      let idContrato = this.$store.getters.contratoStored;
      //let id = this.id;
      let dvExa = this.obtenerDv(this.rutExaminador);
      let rutExa = this.obtenerSoloRut(this.rutExaminador);

      this.body = {
        idContrato: idContrato,
        rut: rutExa,
        dv: dvExa,
        codigoCurso: this.codigoCurso,
        nivel: this.nivel,
        observaciones: this.observacionesExa,
        rol: this.rolValue,
        idAsignacion: this.id,
      };
      axios
        .post("candidatos/seleccion/procesar/solicitudCambio", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.volver();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error);
        });
    },
  },
};
</script>
